import * as React from "react";
import { UserMessage } from "./userMessageTypes";
import Button from "@material-ui/core/Button";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Dialog from "material-ui/Dialog";

type Props = {
  userMessage: UserMessage;
  onClose: Function;
  expireUserMessage?: any;
};

type State = {
  expiring: boolean;
};

class ExpirePageModal extends React.Component<Props, State> {
  state = { expiring: false };

  onExpire = (): void => {
    this.setState({ expiring: true });
    this.props
      .expireUserMessage({
        variables: {
          id: this.props.userMessage.id
        }
      })
      .then(() => this.props.onClose({ refetchData: true }))
      .catch(error => {
        alert(error);
      })
      .finally(() => this.setState({ expiring: false }));
  };

  render() {
    return (
      <Dialog
        title="Expire User Message"
        modal={false}
        open={this.props.userMessage != null}
        actions={[
          <Button color="secondary" onClick={() => this.props.onClose()}>
            No
          </Button>,
          <Button
            disabled={this.state.expiring}
            color="primary"
            onClick={this.onExpire}
          >
            {this.state.expiring ? "Expiring..." : "Yes"}
          </Button>
        ]}
        onRequestClose={this.props.onClose}
      />
    );
  }
}

const expireUserMessage = graphql<Props, any, any>(
  gql`
    mutation expireUserMessage($id: ID!) {
      expire_user_message(id: $id) {
        id
      }
    }
  `,
  { name: "expireUserMessage" }
);

export default compose(expireUserMessage)(ExpirePageModal);
